module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-08-ec27e2bce5cb65944eb2d0109e2e3f55.jpg";